import React from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DeleteDialogProps {
  onDelete: () => Promise<void>;
  deleteConfirmationText: React.ReactNode;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void; // Add this prop
  title?: string; // Optional title prop
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({ onDelete, deleteConfirmationText, isOpen, onOpenChange, title }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title ?? "Delete"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>{deleteConfirmationText}</div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            className="bg-red-500"
            onClick={async () => {
              try {
                await onDelete(); // Wait for the async operation
                onOpenChange(false); // Close the dialog after deletion
              } catch (error) {
                console.error("Error deleting", error);        
              }
            }}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDialog;
